
import { computed, defineComponent, onMounted, reactive, ref } from 'vue'
import { useReflectiveInjector, Type } from '@tanbo/vue-di-plugin'
import { LoginService } from './login.service'
import FastLogin from './_components/fast-login.vue'
import PhoneLogin from './_components/kantu-phone-login.vue'
import OfficiaLogin from './_components/official-login.vue'
import KantuFooter from '@/components/footer/kantuFooter.vue'
import Tabs from '@/components/tabs/index.vue'
import SingleTab from '@/components/single-tab/index.vue'
import WxWebLogin from './_components/wx-web-login.vue'
import { ConfigService, product_id_info } from '@/services/config.service'
import { BridgeService, OLD_ACCOUNT_STATUS } from '@/services/bridge.service'
import { CookieService } from '@/services/cookie.service'
import { isInFrame, sendMessageToParent } from '@/utils/frame'

export default defineComponent({
  name: 'Login',
  components: {
    FastLogin,
    PhoneLogin,
    OfficiaLogin,
    KantuFooter,
    Tabs,
    SingleTab,
    WxWebLogin
  },
  setup() {
    const injector = useReflectiveInjector([LoginService])
    const config = injector.get(ConfigService as Type<ConfigService>)
    const bridge = injector.get(BridgeService)
    const cookie = injector.get(CookieService)
    const isShowOldAccount = ref(true)

    const viewModel = reactive({
      logo: config.getLogo,
      title: config.getTitle,
      tabIdx: 0, // tab下标
      officialLoginImg: config.getOfficialLoginImg,
      oldAccountLoginInfo: config.getOldAccountLoginInfo,
      showFastLogin: false /** 是否显示快速登录 */,
      tabs: ['微信登录', '手机登录'],
      productId: cookie.productId ? Number(cookie.productId) : undefined,
      wxWebAppId: config.wxWebAppId || ''
    })

    const isShow = computed(() => {
      if (viewModel.oldAccountLoginInfo?.text) {
        if (viewModel.productId === product_id_info.pdf || viewModel.productId === product_id_info.pdfConvert) {
          return isShowOldAccount.value
        }
        return true
      }
      return false
    })

    /**
     * @description 是否为 win看图大师产品（6290/151 或 6291/154）
     * 两个产品均仅保留微信网站应用扫码登录，屏蔽手机登录入口。
     */
    const isAiImageEditor = computed(() => {
      return viewModel.productId === product_id_info.aiImageEditor ||
        viewModel.productId === product_id_info.aiImageEditor6291
    })

    /**
     * @description 切换tab
     */
    function toggleTab(idx: number) {
      if (viewModel.tabIdx === idx) {
        return
      }

      viewModel.tabIdx = idx
    }

    /**
     * @description 更新快速登录状态
     */
    function updateFastLogin(bool) {
      viewModel.showFastLogin = bool
    }

    function clickClose() {
      if (isInFrame()) {
        sendMessageToParent({
          type: 'close'
        })
      }
      bridge.closeCurrentWindow()
    }

    /**
     * @description 切换老帐号登录
     */
    function switchOldAccountLogin() {
      bridge.switchProduct('login')
    }

    onMounted(() => {
      bridge.isShowOldAccount().then((value) => {
        const isShow = value.result === OLD_ACCOUNT_STATUS.SHOW
        isShowOldAccount.value = isShow
      })
    })

    return {
      isShow,
      viewModel,
      isAiImageEditor,
      toggleTab,
      clickClose,
      updateFastLogin,
      switchOldAccountLogin
    }
  }
})
